import { useEffect, useState } from "react";
import Scorer from "xgboost-scorer";
import XGBoostModel from "./xgboost_ef.json";

const colors = [
  "#008000",
  "#168b00",
  "#2e9700",
  "#44a200",
  "#5cae00",
  "#72b900",
  "#8ac500",
  "#a0d000",
  "#b8dc00",
  "#cee700",
  "#e6f300",
  "#fcfe00",
  "#ffea00",
  "#ffd400",
  "#ffbc00",
  "#ffa600",
  "#ff8e00",
  "#ff7600",
  "#ff6000",
  "#ff4800",
  "#ff3200",
  "#ff1a00",
  "#ff0400",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
  "#ff0000",
];
const significantDimensions = [0, 4, 5, 7, 8, 9, 10, 11, 12, 14, 15, 16, 18, 21, 22, 24, 25, 26, 29, 30, 31];

async function getXGBoostPrediction(significantSliders: Array<number>): Promise<any> {
  const scorer = await Scorer.create(XGBoostModel);
  const score = scorer.score(significantSliders.reduce((a, v, i) => ({ ...a, [`f${String(i)}`]: v }), {}));
  return score;
}

function PredictionReducedEF(sliders: number[]): number {
  const significantSliders = significantDimensions.map((i) => sliders[i]);
  const [prob, setProb] = useState<any>([]);

  useEffect(() => {
    getXGBoostPrediction(significantSliders).then((array) => setProb(Math.round(array * 100)));
  }, significantSliders);

  return prob;
}

export const algorithms: Array<{ text: string; baseValue: number; colors: string[]; probability: { (sliders: number[]): number } }> = [
  {
    text: "Risk of ejection fraction below 40%",
    baseValue: 11,
    colors: colors,
    probability: PredictionReducedEF,
  },
];
